import React, { Fragment } from 'react'

// config
import l, { isBp } from 'config/localization'

// assets
const orgIcon = 'assets/images/icon-group.svg'
import { ReactComponent as VerifiedIcon } from 'assets/images/icons/verified-org.svg'

// styles
import {
  BeneficiaryDetailsWrapper,
  BeneficiaryLogoWrapper,
  BeneficiaryNameLink,
  BeneficiaryNameWrapper,
  HostOrgDetails,
  MastheadWrapper,
  MastheadWrapperInner,
  OpportunityPartnerDetails,
  OpportunityPartnersHeading,
  OpportunityPartnersWrapper,
  OpportunityInner,
  OpportunityOuter,
  Outer,
  OrgLink,
  OrgLogo,
  OrgLogoWrapper,
  SingleOpportunityPartner,
  SocialMediaWrapper,
  VerificationIcon,
  VerificationStatus,
  VerificationWrapper
} from './styles'

// Load components synchronously
import ConditionalDisplay from 'components/ConditionalDisplay/ConditionalDisplay'
import SocialMediaIcons from 'components/SocialMediaIcons/SocialMediaIcons'

const getBeneficiaryDetails = ({ beneficiaryOrg }) => {
  if (!beneficiaryOrg) {
    return {
      orgPageLink: '#',
      isVerified: false,
      logoSrc: orgIcon,
      orgName: ''
    }
  }

  const orgPageLink = beneficiaryOrg.url_name
    ? `/${l('ROUTE_ORGS')}/${beneficiaryOrg.url_name}`
    : '#'

  return {
    orgPageLink,
    isVerified: beneficiaryOrg.is_verified,
    logoSrc: beneficiaryOrg.logo_image || orgIcon,
    orgName: beneficiaryOrg.name || ''
  }
}

const Masthead = ({
  align = 'initial',
  beneficiaryOrg,
  children,
  image,
  opportunity = {},
  roundBorders
}) => {
  const hasOpportunity = opportunity && opportunity.id

  if (!isBp && !!hasOpportunity) {
    const { description = '', title } = opportunity
    const shortDescription = description.replace(/^(.{40}[^\s]*).*/, '$1...')
    const { logoSrc, orgPageLink } = getBeneficiaryDetails({ beneficiaryOrg })

    return (
      <OpportunityOuter>
        <OpportunityInner beneficiaryOrg={beneficiaryOrg}>
          <Fragment>
            <ConditionalDisplay displayWhen={[beneficiaryOrg]}>
              <BeneficiaryDetailsWrapper>
                <OrgLink href={orgPageLink}>
                  <BeneficiaryLogoWrapper>
                    <OrgLogo src={logoSrc} />
                  </BeneficiaryLogoWrapper>
                </OrgLink>
              </BeneficiaryDetailsWrapper>
            </ConditionalDisplay>
          </Fragment>

          <SocialMediaWrapper>
            <SocialMediaIcons title={title} description={shortDescription} isShareModal />
          </SocialMediaWrapper>
        </OpportunityInner>

        <MastheadWrapper image={image} roundBorders={roundBorders} />
      </OpportunityOuter>
    )
  }

  if (isBp && !!hasOpportunity) {
    const { description = '' } = opportunity
    const shortDescription = description.replace(/^(.{40}[^\s]*).*/, '$1...')
    const { isVerified, logoSrc, orgName, orgPageLink } = getBeneficiaryDetails({ beneficiaryOrg })

    return (
      <OpportunityOuter>
        <OpportunityInner beneficiaryOrg={beneficiaryOrg}>
          <Fragment>
            <ConditionalDisplay displayWhen={[beneficiaryOrg]}>
              <BeneficiaryDetailsWrapper>
                <OrgLink href={orgPageLink}>
                  <BeneficiaryLogoWrapper>
                    <OrgLogo src={logoSrc} />
                  </BeneficiaryLogoWrapper>
                </OrgLink>

                <BeneficiaryNameWrapper>
                  For <BeneficiaryNameLink href={orgPageLink}>{orgName}</BeneficiaryNameLink>
                </BeneficiaryNameWrapper>

                <ConditionalDisplay displayWhen={[isVerified]}>
                  <VerificationWrapper>
                    <VerificationIcon src={VerifiedIcon} />
                    <VerificationStatus>Verified nonprofit</VerificationStatus>
                  </VerificationWrapper>
                </ConditionalDisplay>
              </BeneficiaryDetailsWrapper>
            </ConditionalDisplay>
          </Fragment>

          <SocialMediaWrapper>
            <SocialMediaIcons
              title={opportunity.title}
              description={shortDescription}
              isShareModal
            />
          </SocialMediaWrapper>
        </OpportunityInner>

        <MastheadWrapper image={image} roundBorders={roundBorders} />
      </OpportunityOuter>
    )
  }

  const { opportunityPartners = [] } = opportunity
  const hasOppPartners = opportunityPartners.length > 0

  return (
    <Outer>
      <MastheadWrapper image={image} roundBorders={roundBorders}>
        <MastheadWrapperInner align={align}>{children}</MastheadWrapperInner>

        <ConditionalDisplay displayWhen={[hasOppPartners]}>
          <OpportunityPartnerDetails>
            <OpportunityPartnersHeading>in partnership with</OpportunityPartnersHeading>

            <OpportunityPartnersWrapper>
              {opportunityPartners.map(partner => (
                <SingleOpportunityPartner key={`opportunity_partner_${partner.id}`}>
                  <HostOrgDetails>
                    <OrgLink href={partner.org_link}>
                      <OrgLogoWrapper>
                        <OrgLogo src={partner.org_logo || orgIcon} />
                      </OrgLogoWrapper>
                    </OrgLink>

                    <span>
                      <OrgLink ishost href={partner.org_link}>
                        {partner.org_name}
                      </OrgLink>
                    </span>
                  </HostOrgDetails>
                </SingleOpportunityPartner>
              ))}
            </OpportunityPartnersWrapper>
          </OpportunityPartnerDetails>
        </ConditionalDisplay>
      </MastheadWrapper>
    </Outer>
  )
}

export default Masthead
